import React from "react";

const Footer = () => {
  var d = new Date();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Version 4.7.4
          {/* Copyright © Designed &amp; Developed by{" "}
          <a href="https://www.infinitelinked.com/" target="_blank" rel="noreferrer">
            Infinitelinked Solutions Pvt Ltd
          </a>{" "}
          {d.getFullYear()} */}
        </p>
      </div>
    </div>
  );
};

export default Footer;
